
define('payment/handlers/sendHandlers/externalWindowIframeHandler',['jquery', 'payment/externalPopupWindow', 'boxes/helpers/box-loading', 'boxes/helpers/payment-sender-helper'], function ($, externalPopupWindow, boxLoading, paymentSenderHelper) {
	'use strict';

	var methodName;
	var externalWindow;

	function init(methodNameIn) {
		methodName = methodNameIn;
		// Create popup window if we need it later, it has to be created before post otherwise stopped by popup blockers
		externalWindow = externalPopupWindow.getExternalWindow(methodName, 'providerPopupWindowEmpty');
	}

	function handleSuccessfulResponse(paymentBox, sendHandlerData, accHistRef, paymentFetchResultFlow) {
		var externalWindowIframeInformation = sendHandlerData;

		var iframeSrc = paymentSenderHelper.createUrlWithParameters(externalWindowIframeInformation.externalUrl,
			externalWindowIframeInformation.externalParameters);
		var urlWithParameters = paymentSenderHelper.createUrlWithParameters('/pp',
			{
				flow : externalWindowIframeInformation.redirectToInternalWindowFlow,
				GSON_PARAMETER : externalWindowIframeInformation.pageGsonParameter,
				iframeSrc: iframeSrc
			});
		externalWindow.location = urlWithParameters;

		// We assume that provider redirected entire window (otherwise use external panel instead),
		// If needed to detect redirected iframe, then do that with
		// externalWindow.$('#provider-iframe').contents().find('#PLAYER_REDIRECT_POPUP_WINDOW').length > 0;
		externalPopupWindow.handleCloseAndPlayerRedirect(
			externalWindow, paymentBox, boxLoading, externalWindowIframeInformation.asynchronousResult, accHistRef, paymentFetchResultFlow);
	}

	function cleanupOnFail() {
		externalWindow.close();
	}

	var externalWindowIframeHandler = {};
	externalWindowIframeHandler.init = init;
	externalWindowIframeHandler.handleSuccessfulResponse = handleSuccessfulResponse;
	externalWindowIframeHandler.cleanupOnFail = cleanupOnFail;
	return externalWindowIframeHandler;
});

